import React from "react";
import "./Home.css";

const Home = () => (
  <div className="home">

    <div className="top-text">
      <p className="line1">
        School of Indian Karate <span className="registered-symbol">(R)</span>
      </p>
    </div>

    <div className="main-logo">
      <img src="/images/logo-removebg.png" alt="Main Logo" />
    </div>
    
    {/* Animated text lines */}
    <div className="bottom-text">
        <p className="line line2">ISO 9001:2015 Certified</p>
        <div className="line3-container">
          <p className="line line3">Recognized by All India-Do Karate Federation (AIKF)</p>
          <p className="line line3">Recognized by Govt. of India as National Sports Federation(NSF)</p>
          <p className="line line3">Recognized by World Karate Federation (WKF)</p>
        </div>
      </div>
  </div>
);

export default Home;